const enum VariantTypeEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Cta = 'cta',
  Deco = 'deco',
}

export default VariantTypeEnum;
